import { ICandle } from '../DexDatafeed';

/**
 * Make next candle open equal prev candle close
 * @param input candles array
 * @returns candles array
 */
const normalizeCandles = (input: ICandle[]): ICandle[] => {
  for (let i = 0, len = input.length; i < len; i++) {
    if (i > 0) {
      input[i].open = input[i - 1].close;
    }
  }
  return input;
};

export default normalizeCandles;
